import { Organization }        from '@app/modules/organization/models/organization.model';
import { OrganizationState }   from '@app/modules/organization/store/organization.state';
import { ImportTypeEnum }      from '@app/modules/structure-import/models/structure-import.model';
import { ActionTypeWithProps } from '@core/interfaces/store.interface';
import {
	adapterActions,
	IAdapterActions,
	IBaseProps
}                              from '@core/store/adapter/adapter.actions';
import {
	createAction,
	props
}                              from '@ngrx/store';


export interface IOrganizationActions extends IAdapterActions<Organization> {
	updateOrganizationState: ActionTypeWithProps<IPropsUpdateOrganizationState>;
	structureImportForOrganization: ActionTypeWithProps<IPropsImportForOrganization>;
	structureExportForOrganization: ActionTypeWithProps<IPropsOrganizationEntity>;
	hasActiveBusinessPremisesChildren: ActionTypeWithProps<IPropsOrganizationEntity>;
}


export interface IPropsUpdateOrganizationState extends IBaseProps {
	stateUpdateData?: OrganizationState;
}

export interface IPropsDeleteEntity extends IBaseProps {
	entityId: string;
	dialogConfirmationText: string;
}

export interface IPropsImportForOrganization extends IBaseProps {
	importType: ImportTypeEnum.ORGANIZATION;
}

export interface IPropsOrganizationEntity extends IBaseProps {
	organization: Organization;
}


export function organizationActions( storeId: string ) {
	return {
		// AdapterActions ##########################################################################################################################
		...adapterActions<Organization>( storeId ),

		// ORGANIZATION SPECIFIC ACTIONS ###########################################################################################################
		updateOrganizationState: createAction( `[${ storeId }] State Update`, props<IPropsUpdateOrganizationState>() ),
		structureImportForOrganization: createAction( `[${ storeId }] StructureImport`, props<IPropsImportForOrganization>() ),
		structureExportForOrganization: createAction( `[${ storeId }] StructureExport`, props<IPropsOrganizationEntity>() ),
		hasActiveBusinessPremisesChildren: createAction( `[${ storeId }]  check hasActiveBusinessPremisesChildren`, props<IPropsOrganizationEntity>() )
	};
}
